import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    Grid,
    TextField
} from "@mui/material";
import {InputWidget} from "../../../models/contents.ts";
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {Thumbnail} from "../../misc/thumbnail.tsx";

function GimmickForm(props: {
    widgetId: string
    idx: number,
    value: InputWidget.Gimmick,
    onChange: (idx: number, value: InputWidget.Gimmick) => void,
    onDelete: (idx: number) => void,
}) {
    const [open, setOpen] = useState(false)
    const form = props.value;

    const setForm = (form: InputWidget.Gimmick) => {
        props.onChange(props.idx, form)
    }

    return (
        <>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        type="number"
                        label="position x"
                        value={props.value.x}
                        onChange={(event) => {
                          if (Number(event.target.value) < 0) {
                            return
                          }
                          setForm({...form, x: Number(event.target.value)})
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        type="number"
                        label="position y"
                        value={props.value.y}
                        onChange={(event) => {
                          if (Number(event.target.value) < 0) {
                            return
                          }
                          setForm({...form, y: Number(event.target.value)})
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                      fullWidth
                      label="width when displayed"
                      type="number"
                      value={props.value.w}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          if (Number(event.target.value) < 0) {
                              return
                          }
                          setForm({
                              ...form,
                              w: Number(event.target.value),
                          })
                      }}
                    />
                </Grid>
                <Grid item xs={1}>
                  <Button onClick={() => setOpen(true)}>
                    <DeleteIcon/>
                  </Button>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="url Default"
                      value={form.url_default}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setForm({
                              ...form,
                              url_default: event.target.value,
                          })
                      }}
                    />
                </Grid>
                <Grid item xs={2}>
                    {form.url_default && <Thumbnail url={form.url_default} />}
                </Grid>
                <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="url Selected"
                      value={form.url_selected}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          setForm({
                              ...form,
                              url_selected: event.target.value,
                          })
                      }}
                    />
                </Grid>
                <Grid item xs={2}>
                    {form.url_selected && <Thumbnail url={form.url_selected} />}
                </Grid>
            </Grid>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Delete Gimmick?</DialogTitle>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={() => {
                        setOpen(false)
                        props.onDelete(props.idx)
                    }}>Delete</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default GimmickForm;
